import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { IDiscountShort } from '../../../../pricing/interfaces';
import { getDiscountText } from '../utils';
import { useCurrentTabShownCurrency, usePriceConfig } from '../../../../../state';

interface IPromoActivatedGifts {
  discountData: IDiscountShort;
}

const PromoDiscountView: FC<IPromoActivatedGifts> = (props) => {
  const { discountData } = props;

  const priceConfig = usePriceConfig();
  const currency = useCurrentTabShownCurrency();

  const { t: translation } = useTranslation();

  const { active, discountType, value } = discountData;
  const isNeedToShowDiscount = active && value;
  if (!isNeedToShowDiscount) {
    return null;
  }

  return (
    <div>
      {translation('billing.promocode.activeDiscount')}
      :
      &nbsp;
      {getDiscountText({ value, discountType, priceConfig, currency })}
    </div>
  );
};

export default PromoDiscountView;
